import axiosClient from 'api/config/axiosClient';

const getListProductLog = ({ keyword }) => {
  const url = `v1/product/logs?keyword=${encodeURIComponent(keyword)}`;
  return axiosClient.get(url);
};

const getListVisited = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  timeZoneId,
  productId,
}) => {
  const url = `v1/logging/access-ranking/page?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&timeZoneId=${timeZoneId}&filterId=${productId}`;

  return axiosClient.get(url, { timeout: 0 });
};

const getListVisitedAccounts = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  timeZoneId,
  productId,
}) => {
  const url = `v1/logging/access-ranking/page/accounts?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&timeZoneId=${timeZoneId}&filterId=${productId}`;

  return axiosClient.get(url, { timeout: 0 });
};

const getListVisitedPartners = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  timeZoneId,
  productId,
}) => {
  const url = `v1/logging/access-ranking/page/partners?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&timeZoneId=${timeZoneId}&filterId=${productId}`;

  return axiosClient.get(url, { timeout: 0 });
};

const loggingPage = (payload) => {
  const url = 'v1/logging/page-view';
  return axiosClient.post(url, {
    ...payload,
    url: document.URL,
    pageTitle: document.title,
  });
};

export {
  getListProductLog,
  getListVisited,
  getListVisitedAccounts,
  getListVisitedPartners,
  loggingPage,
};
